export default __webpack_public_path__ + "static/media/04_Livingroom-Interior-Architecture-EschweilerPhotography_M1A9723.12f0d803.jpg";